/**
 * @generated SignedSource<<fefc06a49ce0ecc47698abfc73db4719>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TransformChainSetInputObject = {
  stakeholderId: string;
  steps: ReadonlyArray<TransformStepInputObject>;
};
export type TransformStepInputObject = {
  anchorJson?: string | null | undefined;
  kind: string;
  paramsJson?: string | null | undefined;
};
export type stakeholderDetailPage_TransformChainSetMutation$variables = {
  input: TransformChainSetInputObject;
};
export type stakeholderDetailPage_TransformChainSetMutation$data = {
  readonly transformChainSet: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
      readonly transformChain: {
        readonly enabled: boolean;
        readonly steps: ReadonlyArray<{
          readonly anchorJson: string | null | undefined;
          readonly kind: string;
          readonly ordinal: number;
          readonly paramsJson: string;
        }>;
      };
    } | null | undefined;
  } | null | undefined;
};
export type stakeholderDetailPage_TransformChainSetMutation = {
  response: stakeholderDetailPage_TransformChainSetMutation$data;
  variables: stakeholderDetailPage_TransformChainSetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paramsJson",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchorJson",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stakeholderDetailPage_TransformChainSetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TransformChainSetMutationPayload",
        "kind": "LinkedField",
        "name": "transformChainSet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Stakeholder",
            "kind": "LinkedField",
            "name": "stakeholder",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TransformChain",
                "kind": "LinkedField",
                "name": "transformChain",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransformStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stakeholderDetailPage_TransformChainSetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TransformChainSetMutationPayload",
        "kind": "LinkedField",
        "name": "transformChainSet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Stakeholder",
            "kind": "LinkedField",
            "name": "stakeholder",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TransformChain",
                "kind": "LinkedField",
                "name": "transformChain",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransformStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7a31a6be1d12e60cf9fcc36681773638",
    "id": null,
    "metadata": {},
    "name": "stakeholderDetailPage_TransformChainSetMutation",
    "operationKind": "mutation",
    "text": "mutation stakeholderDetailPage_TransformChainSetMutation(\n  $input: TransformChainSetInputObject!\n) {\n  transformChainSet(input: $input) {\n    stakeholder {\n      id\n      transformChain {\n        enabled\n        steps {\n          ordinal\n          kind\n          paramsJson\n          anchorJson\n          id\n        }\n        id\n      }\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4fcae2dd33820de769c42c9f3f37a35";

export default node;
